import { auth, firestore } from "../backend/firebaseConfig";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { query, collection, where, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";



export const signIn = async (email, password) => {
    try {
        // First, check if the email belongs to an admin
        const adminsRef = collection(firestore, "admins");
        const q = query(adminsRef, where("email", "==", email));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            console.error("Access denied: No admin account found with this email");
            return { error: "Access denied: No admin account found with this email" };
        } 
        else {
            console.log("Admin account found, proceeding with sign-in...");
            
            // Get admin data from Firestore
            const adminDoc = querySnapshot.docs[0];
            const adminData = adminDoc.data();
            
            // Proceed with Firebase Auth sign-in
            const userCredential = await signInWithEmailAndPassword(auth, email, password);

            const isadmin = userCredential.user.email === 'admin@gmail.com';
        


            
            // Return both Firebase user and admin data
            return { 
                user: userCredential.user,
                userData: {
                    uid: userCredential.user.uid,
                    email: userCredential.user.email,
                    displayName: userCredential.user.displayName || adminData.fullname || adminData.name,
                    username: adminData.username || adminData.fullname || email.split('@')[0],
                    isadmin,
                    // Include any additional admin fields from Firestore
                    ...adminData,
                    loginTime: new Date().toISOString()
                }
            };
        }
    } catch (error) {
        console.error("Error signing in:", error);
        return { error: error.message };
    }
};

export const signOutUser = async () => {
    try {
        await signOut(auth);
        console.log("User signed out successfully");
        return { success: true };
    } catch (error) {
        console.error("Error signing out:", error);
        return { error: error.message };
    }
};

export const useAuthStatus = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsLoggedIn(!!user);
            setChecked(true); // Ensures we know the check is complete
        });

        // Clean up the subscription on unmount
        return () => unsubscribe();
    }, []);

    return { isLoggedIn, checked };
};
